import {money, stringMixin} from "../../utils/strings";



let _toArray = (o)=>{
  let a = [];
  for (let k in o){
    a.push({id: k, wgt: o[k].wgt, value: o[k].value});
  }
  a.sort((a, b)=>{return b.wgt - a.wgt});
  return a;
}

export const formatSnapshotString = (timestamp, value, snapshot, showZero=false)=>{
  let snapshotArray = _toArray(snapshot);
  if (showZero===false){
    snapshotArray = snapshotArray.filter(x=>x.wgt>0);
  }
  let snapshotStringArray = snapshotArray.map((x=>{
    return `<span style="color:#eee;font-family:var(--font-title);font-size:12px">${x.id.toUpperCase()}: ${stringMixin.pct(x.wgt)}</span>`
  }))
  snapshotStringArray.unshift(`<b style="color:#eee">Value: ${money(value)}</b>`);
  return snapshotStringArray.join('<br>');

}


export const formatLegendItem = (name, value, valuePercentChange, config) => {
  if (config.hasOwnProperty('format')) {
    let format = config?.format ?? '%';
    let formattedValue = value;
    if (format === '%') {
      formattedValue = `${valuePercentChange?.toFixed?.(config.precision || 2) ?? 0}%`;
    } else if (format === '$') {
      formattedValue = money(value);
    }
    return `<div style="font-family:Inter, sans-serif;color:#45496F;text-transform:capitalize">${name.toUpperCase()} <b>--></b> <b style="color:${config?.color ?? '#000'}">${formattedValue}</b></div>`;
  }
  else {
    return `<div style="font-family:Inter, sans-serif">${config?.prefix??''}${name.toUpperCase()}: <b style="color:${config?.color ?? '#000'}">${value.toFixed(config?.precision??2)}${config?.postfix??''}</b></div>`

  }
};




